import api, { METHODS } from './api'
import { ResponseType } from '../common/types/api/request'

export default async function setKeepRequestJsonAfterProcessFlag(keepRequestJsonAfterProcessFlag: boolean): Promise<ResponseType> {
    const baseErrorMsg = "Error trying to save new value for the flag to keep the request json for the screenshot generated in the report's process"
    try {
        const res = await api<ResponseType>(
            `keepRequestJsonAfterProcessFlag`, // for apache servers
            METHODS.POST,
            `${keepRequestJsonAfterProcessFlag}`
        )

        if (res.error) {
            console.error(baseErrorMsg, res.error)

            return {
                success: false,
                error: res.error
            }
        }

        return res
    } catch (error) {
        // TODO: use logger
        // console.error(error)
        console.error(baseErrorMsg, error)
        
        return {
            success: false,
            error: error
        }
    }
}